import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const forgeCsmQueueRoute: InvariantJiraRoute = {
	name: 'forge-spa-csm-queue',
	path: '/jira/customer-service-management/projects/:projectKey/queues/apps/:appId/:envId/:route?',
};
